; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.stock = inovestor.ms.stock || {};
})(inovestor);


; (function (stock, undefined) {
    // Create plugin namespace with any desired config variable
    stock.financialStatements = {
        config: {
        }
    };

})(inovestor.ms.stock);


; (function ($, ko, inovestor, undefined) {

    inovestor.ms.stock.financialStatements.viewModels = {};

    inovestor.ms.stock.financialStatements.viewModels.financialStatementsViewModel = function () {
        var self = this;

        self.resources = ko.observable();
        self.hasError = ko.observable(false);
        self.isInvalidIdentifier = ko.observable(false);
        self.financialStatement = ko.observable();
        self.hasValidData = ko.computed(function () {
            return !self.hasError() && !self.isInvalidIdentifier() && self.financialStatement() != null;
        }, this);

        self.expectionSeperatorHtml = '<hr style="margin: 3px 0"/>';

        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.stock.financialStatements.resources[inovestor.ms.core.currentLanguage];
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null;
            self.resources(currentResource);
        };
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsStockFinancialStatements';

    // Create the plugin constructor
    function Plugin(element, options) {

        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsStockFinancialStatements.defaults;
        this._viewModel = new inovestor.ms.stock.financialStatements.viewModels.financialStatementsViewModel();
        this._lastParams = {};

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            plugin._prepareStatement(plugin.options.statement)
            plugin._viewModel.financialStatement(plugin.options.statement);

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin.update();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.financialStatements;
            var filePath = plugin.options.templatePaths.financialStatements;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'financialStatements.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.render();
                plugin.bindModel();
            })
                .always(function () {
                    // When search is completed, trigger onReady event
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // This is used so we don't loop multiple times through the model to perform calculations.
        // This method does the following:
        //          Prepare exceptions for the statement
        //          Prepare the chart data for each rows
        _prepareStatement: function (statement) {
            if (statement && statement.summary) {
                statement.exceptions = [];
                var mainUnit = statement.summary.unit;
                var statementRows = statement.rows;
                var statementRowsLength = statementRows.length;
                var statementRowIndex = 0;

                for (statementRowIndex; statementRowIndex < statementRowsLength; statementRowIndex++) {
                    var statementRow = statementRows[statementRowIndex];
                    var statementCells = statementRow.cells;
                    var statementCellsLength = statementCells.length;
                    var statementCellIndex = 0;
                    var exceptionDoneForRow = false;

                    statementRow.chartData = {
                        shouldRender: false,
                        dataItems: []
                    };

                    for (statementCellIndex; statementCellIndex < statementCellsLength; statementCellIndex++) {
                        var statementCell = statementCells[statementCellIndex];
                        if (!exceptionDoneForRow && statementCell.mostRecentValue && mainUnit.localeCompare(statementCell.mostRecentValue.unit) !== 0) {
                            statement.exceptions.push(statementRow.label);
                            exceptionDoneForRow = true;
                        }

                        if (!inovestor.ms.core.isNullOrUndefined(statementCell.mostRecentValue) && !inovestor.ms.core.isNullOrUndefined(statementCell.mostRecentValue.value)) {
                            statementRow.chartData.shouldRender = true;
                            statementRow.chartData.dataItems.push(statementCell.mostRecentValue.value);
                        } else {
                            statementRow.chartData.dataItems.push(0);
                        }

                    }
                }
            }
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },


        // Update resources
        update: function () {
            var plugin = this;
            // Update view model resources
            plugin._viewModel.updateResources();
            plugin._viewModel.financialStatement.valueHasMutated();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        },
    });

    // JQuery Plugin wrapper
    $.fn.inoMsStockFinancialStatements = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsStockFinancialStatements.defaults = {
        statement: null,
        onError: null,
        onReady: null,
        templatePaths: {
            financialStatements: null
        }
    };


})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (stock, undefined) {
    stock.financialStatements.resources = stock.financialStatements.resources || {};
    stock.financialStatements.resources["en"] = {
        valueInMillions: 'All numbers are in millions.',
        valueInBillions: 'All numbers are in billions.',
        valueInThousands: 'All numbers are in thousands.',
        currencyIn: '({currency})',
        noDataToDisplay: 'No data to display.',
        exceptTheFollowing: 'Exceptions',
    };
})(inovestor.ms.stock);

; (function (stock, undefined) {
    stock.financialStatements.resources = stock.financialStatements.resources || {};
    stock.financialStatements.resources["fr"] = {
        valueInMillions: 'En millions.',
        valueInBillions: 'En milliards.',
        valueInThousands: 'En milliers.',
        currencyIn: '({currency})',
        noDataToDisplay: 'Aucune donnée à afficher.',
        exceptTheFollowing: 'Exceptions',
    };
})(inovestor.ms.stock);
